import fetch from '@/plugins/axios'
export default {
	namespaced: true,
	state: {
		list: [],
		pager: {},
		loading: false
	},
	mutations: {
		setState(state: any, { key, data }: any) {
			state[key] = data;
		},
		changeExEdit(state: any, {index, value}: {index: number, value: boolean}){
			state.list[index].edit = value;
		}
	},
	actions: {
		// 获取寄件列表
		async getMailList({ commit }: any, params: any) {
			commit('setState',{key:'loading',data: true})
			const res:any = await fetch({
				url: '/client/delivery',
				method: 'get',
				params
			})
			const result = res.docs.map(item =>{
				item.edit = false;
				return item;
			});
			commit('setState',{key:'list',data: result})
			commit('setState',{key:'pager',data: {limit: res.limit,total: res.total,sizes: 600}})
			commit('setState',{key:'loading',data: false})
		},
		// 添加寄件
		async addMail({ commit }: any, params: any) {
			return await fetch({
				url: '/client/delivery',
				method: 'post',
				data:params
			})
		},
		// 编辑寄件
		async editMail({ commit }: any, params: any) {
			return await fetch({
				url: `/client/delivery/${params.id}`,
				method: 'put',
				data:params.data
			})
		},
		// 获得寄件信息详情
		async getMailDetail({ commit }: any, id: string) {
			return await fetch({
				url: `/client/delivery/${id}`
			})
		},
		// 删除寄件
		async deleteMail({ commit }: any, id: string) {
			return await fetch({
				url: `/client/delivery/${id}`,
				method: 'delete'
			})
		},
		// 请求打印
		async printMail({ commit }: any, id: string) {
			return await fetch({
				url: `/client/eorder/printEorder/${id}`,
				method: 'get'
			})
		},
		// 打印成功发送
		async recordPrinter({ commit }: any, id: string) {
			return await fetch({
				url: `/client/eorder/printSuccess/${id}`,
				method: 'put'
			})
		}
	}
}